import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const row    = event.currentTarget
    const avatar = row.querySelector("[data-contacts-avatar]")
    const checked = row.dataset.checked === "true"

    if (checked) {
      row.dataset.checked = "false"
      row.classList.remove("bg-vouch-blue/20")
      avatar.classList.remove("border-vouch-blue", "bg-vouch-blue", "text-white")
      avatar.classList.add("border-slate-300", "bg-white", "text-slate-700")
      avatar.textContent = row.dataset.initial
    } else {
      row.dataset.checked = "true"
      row.classList.add("bg-vouch-blue/20")
      avatar.classList.add("border-vouch-blue", "bg-vouch-blue", "text-white")
      avatar.classList.remove("border-slate-300", "bg-white", "text-slate-700")
      avatar.textContent = "✓"
    }
  }
}
